import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Bugsnag from "@bugsnag/js";
// import firebasePlugin from "@/utils/firebasePlugin"
import { long2tile, lat2tile } from "../utils/tileFunctions";
import firebase from "firebase/app";
require("firebase/auth");
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA5b4hOnHUeO3y8VEXj8cUvFZO74cQTMMM",
  authDomain: "nv1500.web.app",
  databaseURL: "https://dust-tags.firebaseio.com",
  projectId: "dust-tags",
  storageBucket: "dust-tags.appspot.com",
  messagingSenderId: "576110814804",
  appId: "1:576110814804:web:a9e90b92ccd8c887d9efc1",
};
// https://blog.logrocket.com/vue-firebase-authentication/
firebase.initializeApp(firebaseConfig);

const dbPrefix = "ts-demo-0";
const db = firebase.database();
const accountRootNode = db.ref(dbPrefix).child("account");
const timeSeriesRootNode = db.ref(dbPrefix).child("TS");

// const fbPlugin = firebasePlugin(accountRootNode)

function accountNode(uid) {
  return accountRootNode.child(uid);
}
const emptyProfile = {
  uid: false,
  isAnonymous: true,
  displayName: "",
  email: "",
  photoURL: "",
};

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: dbPrefix,
    }),
  ],
  state: {
    status: { signedIn: false },
    error: [],
    account: {},
    timeSeries: [],
    refreshTime: 0,
    installPrompt: null,
    showInstallPrompt: false,
  },
  mutations: {
    SHOWINSTALLPROMPT(state, value) {
      Vue.set(state, "showInstallPrompt", value);
    },
    CLEARHOUSEHOLD(state) {
      Vue.set(state, "error", []);
      const profile = state.account.profile;
      Vue.set(state, "account", { profile });
      Vue.set(state, "timeSeries", []);
    },
    INSTALL_APP_PROMPT(state, installPrompt) {
      Vue.set(state, "installPrompt", installPrompt);
    },
    REFRESH_UPDATE(state, refreshTime) {
      Vue.set(state, "refreshTime", refreshTime);
    },
    // https://github.com/vuejs/vuex/issues/1311
    SIGNED_IN(state, status) {
      Vue.set(state.status, "signedIn", status);
    },
    SET_PROFILE(state, profile) {
      Vue.set(state.account, "profile", profile);
    },
    SET_ERROR(state, msg) {
      state.error.push(msg); // ?
      Bugsnag.notify(new Error(msg));
    },
    SET_LOCATION(state, location) {
      Vue.set(state.account, "location", location);
      // state.account.location = location; NOT reactive
    },
    ADD_USER(state, user) {
      if (!state.account.users) Vue.set(state.account, "users", []);
      state.account.users.push(user); // TODO check
    },
    // this May be wrong
    UPDATE_USER_KEY(state, { id, key }) {
      state.account.users.forEach((u) => {
        if (u.id === id) {
          Vue.set(u, "key", key);
          return;
        }
      });
    },
    ADD_TIME_SERIES(state, ts) {
      const clone = JSON.parse(JSON.stringify(ts));
      state.timeSeries.push(clone);
      if (state.installPrompt) Vue.set(state, "showInstallPrompt", true);
    },
    UPDATE_TIMESERIES_DATAPOINT_KEY(state, { ts, key }) {
      state.timeSeries.forEach((dp, idx) => {
        // if (dp.ts === ts.ts) orig[idx] = ts;
        if (dp.ts === ts) {
          Vue.set(state.timeSeries[idx], "key", key);
          return;
        }
      });
    },
  },
  actions: {
    setShowInstallPrompt({ commit }, value) {
      commit("SHOWINSTALLPROMPT", value);
    },
    dbReadAccount({ commit }, auid) {
      accountNode(auid)
        .once("value")
        .then((snapshot) => {
          const dbAccount = snapshot.val();
          if (!dbAccount) commit("SET_ERROR", "Empty Account");
          // else TODO
        })
        .catch((error) => commit("SET_ERROR", error));
    },
    async dbCreateUser({ dispatch, commit, getters }, user) {
      const auid = getters.getSignedIn;
      if (!auid) {
        try {
          const auth = await firebase.auth().signInAnonymously();
          dispatch("_dbCreateUser", { user, auid: auth.uid });
        } catch (error) {
          commit("SET_ERROR", error.message);
        }
      } else {
        dispatch("_dbCreateUser", { user, auid });
      }
    },
    _dbCreateUser({ commit }, { user, auid }) {
      accountNode(auid)
        .child("users")
        .push(user)
        .then((pushRef) => {
          commit("UPDATE_USER_KEY", { id: user.id, key: pushRef.key });
        })
        .catch((error) => {
          const json = JSON.stringify(user);
          commit("SET_ERROR", error + " data: " + json);
        });
    },
    dbCreateAccount({ commit, getters }) {
      const account = getters.getAccount,
        auid = account.profile.uid || false;
      if (auid) {
        accountNode(auid)
          .set(account)
          .catch((error) => commit("SET_ERROR", error));
      } else {
        commit("SET_ERROR", "error in dbCreateAccount missing auid");
      }
    },
    dbCreateTimeSeriesDataPoint({ commit }, dataPointTS) {
      timeSeriesRootNode
        .push(dataPointTS)
        .then((pushRef) => {
          commit("UPDATE_TIMESERIES_DATAPOINT_KEY", {
            ts: dataPointTS.ts,
            key: pushRef.key,
          });
        })
        .catch((error) => {
          const json = JSON.stringify(dataPointTS);
          commit("SET_ERROR", error + " data: " + json);
        });
    },
    signInAnonymously({ commit, getters }) {
      if (!getters.getSignedIn) {
        firebase
          .auth()
          .signInAnonymously()
          .catch((error) => commit("SET_ERROR", error.message));
      }
    },
    SetAuthentication({ commit, getters }, auth) {
      if (auth === null) {
        commit("SIGNED_IN", false);
        commit("SET_PROFILE", emptyProfile);
      } else if (auth.uid) {
        if (getters.getProfile && getters.getProfile.uid === auth.uid) {
          return; // noop
        }
        commit("SIGNED_IN", auth.uid);
        const profile = (({
          uid,
          isAnonymous,
          displayName,
          email,
          photoURL,
        }) => ({
          uid,
          isAnonymous,
          displayName,
          email,
          photoURL,
        }))(auth);
        commit("SET_PROFILE", profile);
      } else {
        commit("SET_ERROR", "authentication: no uid");
      }
    },
    setLocation({ commit, dispatch }, { location }) {
      const tileZoom = 15;
      const tiles = {
        X: long2tile(location.center.lng, tileZoom),
        Y: lat2tile(location.center.lat, tileZoom),
        zoom: tileZoom,
      };
      location = { ...location, tiles };
      commit("SET_LOCATION", location);
      dispatch("dbCreateAccount");
    },
    addUser({ commit, dispatch }, user) {
      const id = Date.now();
      user = {
        ...user,
        id: id,
      };
      commit("ADD_USER", user);
      dispatch("dbCreateUser", user);
    },
    // eslint-disable-next-line prettier/prettier
    addUserTimeSeries({ commit, getters, dispatch }, { user, symptoms }) {
      // TODO add delta
      const _account = getters.getAccount;
      const account = {
        tiles: _account.location.tiles,
        id: _account.profile.uid,
      };
      let time = Date.now(); // millisec
      const ts = {
        symptoms,
        ts: time,
        user,
        account,
      };
      commit("ADD_TIME_SERIES", ts);
      dispatch("dbCreateTimeSeriesDataPoint", ts);
    },
    clearHousehold({ commit }) {
      // https://github.com/robinvdvleuten/vuex-persistedstate/issues/88
      // N.B. used to start again
      commit("CLEARHOUSEHOLD");
    },
  },
  getters: {
    // https://github.com/Code-Pop/watch-us-build-trello/blob/master/src/store.js
    getUserTimeSeries(state) {
      return (id) => {
        return state.timeSeries.filter((ts) => ts.user.id === id) || [];
      };
    },
    getUnsyncedTimeSeriesTS(state) {
      return state.timeSeries
        .filter((dp) => dp.key === undefined)
        .map((dp) => dp.ts);
    },
    getUserList(state) {
      return state.account.users || false;
    },
    getLocation(state) {
      return state.account.location || false;
    },
    getAccount(state) {
      return state.account || false;
    },
    getProfile(state) {
      return state.account.profile || false;
    },
    getSignedIn(state) {
      return state.status.signedIn || false;
    },
    getAccountState(state) {
      return state.account || false;
    },
    getRefreshTime(state) {
      return state.refreshTime || 0;
    },
    appVersion() {
      return process.env.VUE_APP_PACKAGE_VERSION;
    },
    getInstallAppPrompt(state) {
      return state.installPrompt || false;
    },
    getShowInstallAppPrompt(state) {
      return state.installPrompt && state.showInstallPrompt;
    },
  },
});
